export enum DASHBOARD_VARIANTS {
    WIDGETS = "widgets",
    AGENT_PERFORMANCE = "agent-performance-dashboard",
}

export const DASHBOARD_VARIANT_OPTIONS = [
    { value: DASHBOARD_VARIANTS.WIDGETS, labelKey: "dashboard_variant_widgets" },
    { value: DASHBOARD_VARIANTS.AGENT_PERFORMANCE, labelKey: "dashboard_variant_agent_performance" },
] as const;
